import { ModalProps } from "antd/lib/modal/Modal";
import { Col, Input, message, Modal, Row } from "antd";
import React, { useContext, useImperativeHandle, useState } from "react";
import {
    addChapter,
    ChapterTree
} from "../../../../../../service/CourseDetail/chapter";
import Style from "./index.module.scss";
import Form, { useForm } from "rc-field-form";
import FieldWithError from "../../../../../../components/FieldWithError";
import ChapterSelect from "../../../../../../components/ChapterSelect";
import useRequestFn from "../../../../../../utils/useRequestFn";
import { CourseContext } from "../../../../Store";
import useCurrentDate from "../../../../../../utils/useCurrentDate";
import { ResultMessage } from "../../../../../../components/ResultMessage";
import { errorMessage } from "../../../../../../service/service";
import "../../../../../../style/public.scss";
import className from "classnames";
interface DataModalInstance {
    setPayload: (payload: any) => void;
}
interface DataModalProps extends ModalProps {
    onOk?: () => void;
    onCancel?: () => void;
    treeData: ChapterTree[];
}
interface FormProps {
    parentId: number;
    chapterName: string;
}

const DataModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ treeData, onOk, onCancel, ...props }, ref) => {
        const [payload, setPayload] = useState({
            parentId: ""
        });
        useImperativeHandle(ref, () => ({
            setPayload: payload => {
                setPayload(payload);
            }
        }));
        const [appendAction, { loading: appendLoading }] =
            useRequestFn(addChapter);

        const [form] = useForm<FormProps>();

        const { course } = useContext(CourseContext);
        const { batchNo } = useCurrentDate();

        async function onFinish(data: FormProps) {
            try {
                await appendAction({
                    chapterName: data.chapterName,
                    dcCourseChapterEntity: {
                        delStatus: "",
                        batchNo,
                        courseNo: course.courseNo,
                        courseSeq: course.courseSeq
                    },
                    parentId: data.parentId
                });
                onOk?.();
                message.success("添加成功");
            } catch (e) {
                ResultMessage.error(errorMessage(e));
            }
        }

        return (
            <Modal
                {...props}
                onCancel={onCancel}
                onOk={form.submit}
                maskClosable={false}
                title="添加子级"
                okButtonProps={{
                    loading: appendLoading
                }}>
                <Form form={form} onFinish={onFinish} className={Style.root}>
                    <Row className={Style.mt}>
                        <Col span={6}>
                            <div
                                className={className(
                                    "required_overflow",
                                    "label32"
                                )}>
                                标题：
                            </div>
                        </Col>

                        <Col span={16}>
                            <FieldWithError
                                name="chapterName"
                                rules={[
                                    { required: true, message: "请输入标题" }
                                ]}>
                                <Input
                                    required
                                    placeholder="请输入标题"
                                    maxLength={200}
                                />
                            </FieldWithError>
                        </Col>
                    </Row>
                    <Row className={Style.mt}>
                        <Col span={6}>
                            <div className={className("label32")}>
                                所属父级：
                            </div>
                        </Col>
                        <Col span={16}>
                            <Form.Field
                                name="parentId"
                                initialValue={payload.parentId}>
                                {({ value, onChange }) => {
                                    return (
                                        <ChapterSelect
                                            targetKey="APPEND"
                                            value={value}
                                            onChange={onChange}
                                        />
                                    );
                                }}
                            </Form.Field>
                            <p className={Style.tips}>
                                温馨提示：章节列表按时间升序顺序显示，后添加成功的在章节列表的最下方
                            </p>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
);

export default DataModal;
